import { render, staticRenderFns } from "./Typo.vue?vue&type=template&id=15a313f5&scoped=true&"
import script from "./Typo.vue?vue&type=script&lang=js&"
export * from "./Typo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a313f5",
  null
  
)

export default component.exports